import "../styles/pages.scss";
import backgroud from "../assets/img/archiveBack.png";
import scroll from "../assets/img/Scroll.png";
import { ArchiveCard } from "../components/ArchiveCard";
import archivePic2 from "../assets/img/archivePic2.png";
import archivePic3 from "../assets/img/archivePic3.png";
import { GetTravelDataAll } from "../Location";
import { Data } from "../Location";
import { useEffect, useState } from "react";

function GetCard(num, travelData) {
    return (
        <ArchiveCard
            link={"/detail?num=" + num}
            img={travelData ? travelData[num].detailImg : ""}
            date={travelData ? travelData[num].detail.startShort : ""}
            title={travelData ? travelData[num].name : ""}
            text={travelData ? travelData[num].detail.shortDescription : ""}
            rate={travelData ? travelData[num].detail.star : ""}
        />
    );
}

export function PackageArchive() {
    const [data, setData] = useState(null);
    const [travelData, setTravelData] = useState(null);
    useEffect(() => {
        Data().then((r) => {
            setData(r);
        });
        GetTravelDataAll().then((r) => {
            setTravelData(r);
            console.log(r);
        });
    }, []);
    return (
        <div className="page">
            <img className="pageBackground" src={backgroud} />
            <div className="pageTop">
                <div className="archiveTitle1">
                    {data ? data.archive.MainText : ""}
                </div>
            </div>
            <div className="pageContent1">
                <img className="archivePic2" src={archivePic2} />
                <div className="archivePageContent">
                    <div className="archiveContent">
                        <div className="archiveMain">
                            <div className="archiveInner">
                                {travelData &&
                                    travelData.map((i, index) => {
                                        return GetCard(index, travelData);
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
                <img className="archivePic3" src={archivePic3} />
            </div>
        </div>
    );
}
